//const server="https://demoonedrive.firmasdigitales.co/";
const server="/";
export const clientID='demood';
//export const clientID='';
export const URL=server +"demoOneDrive/";
export const clientURL=server + "signerod/#/";
export const signerURL=server + "netcosigner" + clientID + "/";
export const advisorProfile="4";
export const managerProfile="3";